export default "__VITE_ASSET__1d9ee979__"